const $inject = ['$rootScope', '$http'];
const hotelsService = function ($rootScope, $http) {
  let service = {
    loading: false,
    mergeSuccess: false,
    hotelMaster: undefined,
    hotelsToDupe: [],
    addHotel: addHotel,
    clearAll: clearAll,
    swapMaster: swapMaster,
    merge: merge,
    removeHotel: removeHotel,
    disableHotel: disableHotel,
    getHotel: getHotel,
    putHotel: putHotel,
  };

  function addHotel(hotel) {
    if (service.mergeSuccess) {
      service.mergeSuccess = false;
      service.hotelMaster = undefined;
      service.hotelsToDupe = [];
    }
    
    if (!service.hotelMaster || service.hotelMaster === hotel) {
      service.hotelMaster = hotel;
    } else {
      if (!service.hotelsToDupe.includes(hotel)) {
        service.hotelsToDupe.push(hotel)
      }
    }
  }

  function clearAll() {
    service.mergeSuccess = false;
    service.hotelMaster = undefined;
    service.hotelsToDupe = [];
  }

  function swapMaster(hotel, index) {
    service.hotelsToDupe.splice(index, 1);
    service.hotelsToDupe.push(service.hotelMaster);
    service.hotelMaster = hotel;
  }

  function merge() {
    service.loading = true;
    let targetHotelId = service.hotelMaster.Id;
    let providerHotelIds = _.flatten(service.hotelsToDupe.map(hotel => {
      return hotel.Providers.map(provider => {
        return provider.Id
      })
    }));

    let payload = {targetHotelId, providerHotelIds};
    $http.put(`${endPointUrl}/api/v2/Hotels/Dedupe`, payload)
      .then(() => {
        service.loading = false;
        service.mergeSuccess = true;
        $rootScope.$emit('hotelsService.mergeSuccess')

      })
      .catch((err) => {
        console.log(err);
      });
  }

  function removeHotel(index) {
    service.hotelsToDupe.splice(index, 1);
  }
  
  function disableHotel(hotel) {
    $http.put(`${endPointUrl}/api/v2/Hotels/Update`, hotel)
      .then(() => {
        console.log('hotel', hotel);
      })
      .catch((err) => {
        console.log(err);
      });
  }

  function getHotel(hotelId) {
    return $http.get(`${endPointUrl}/api/v2/Hotels/GetHotelById/${hotelId}`);
  }

  function putHotel(hotel) {
    return $http.put(`${endPointUrl}/api/v2/Hotels/Update`, hotel);
  }

  return service;
};

hotelsService.$inject = $inject;

export default hotelsService;


// WEBPACK FOOTER //
// ./src/services/hotelsService.js